import { CleanedData, ReportData } from "../types/global.d";
import i18n from 'i18next';

const ACTION_PLAN_KEYS: Record<number, string> = {
  0: "actionPlan.cleanMyselfShort",
  1: "actionPlan.needHelpWithCleanup",
  2: "actionPlan.groupCleanupPlanned",
};

const POLLUTION_LEVEL_KEYS = [
  { max: 10, key: "pollution.lowPollution" },
  { max: 20, key: "pollution.mediumPollution" },
  { max: Infinity, key: "pollution.heavyPollution" },
];

const AREA_KEYS: Record<number, string> = {
  1: "pollution.within100m",
  2: "pollution.within500m",
  3: "pollution.within1km",
};

const TRASH_TYPE_KEYS: Record<number, string> = {
  1: "trash.householdWaste",
  2: "trash.constructionDebris",
  3: "trash.hazardousWaste",
  4: "trash.liquidWaste",
};

const CLEANUP_TYPE_KEYS: Record<number, string> = {
  0: "cleanup.cleanedByReporter",
  1: "cleanup.communityCleanup",
  2: "cleanup.administrationCleanup",
};

const pluralizeBags = (amount: number) => {
  const bagKey = amount === 1 ? "pollution.bag" : "pollution.bags";
  return `${amount} ${(i18n.t as any)(bagKey)}`;
};

export const getActionPlanLabel = (report: ReportData) => {
  if (report.action === undefined || report.action === null) {
    return null;
  }
  const key = ACTION_PLAN_KEYS[report.action];
  return key ? (i18n.t as any)(key) : `Action plan #${report.action}`;
};

export const getPollutionAmountLabel = (amount?: number | null) => {
  if (typeof amount !== "number") {
    return null;
  }
  const levelItem = POLLUTION_LEVEL_KEYS.find(({ max }) => amount < max);
  const level = levelItem ? (i18n.t as any)(levelItem.key) : null;
  return level ? `${pluralizeBags(amount)} (${level})` : pluralizeBags(amount);
};

export const getPollutionAreaLabel = (area?: number | null) => {
  if (typeof area !== "number") {
    return null;
  }
  const key = AREA_KEYS[area];
  return key ? (i18n.t as any)(key) : `Area option #${area}`;
};

export const getTrashTypeText = (trashTypes?: number[] | null) => {
  if (!trashTypes || trashTypes.length === 0) {
    return null;
  }
  const labels = trashTypes
    .map((type) => {
      const key = TRASH_TYPE_KEYS[type];
      return key ? (i18n.t as any)(key) : `Type #${type}`;
    })
    .filter(Boolean);

  if (labels.length === 0) {
    return null;
  }

  return labels.join(", ");
};

export const getCleanupTypeLabel = (cleaned?: CleanedData | null) => {
  if (!cleaned) {
    return null;
  }
  const value =
    cleaned.cleaner !== undefined && cleaned.cleaner !== null
      ? cleaned.cleaner
      : cleaned.amount && cleaned.amount > 0
      ? 1
      : 0;

  const key = CLEANUP_TYPE_KEYS[value];
  return key ? (i18n.t as any)(key) : `Cleanup type #${value}`;
};
